import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';

import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPDimensionShotViewer from '../PDPDimensionShotViewer';

// Cylindo dimension shots when the product has them, else the static image
const PDPDimensionsImage = ({
  dimensionsDesktopImage,
  dimensionsMobileImage,
  onImageClick,
  isSidebarContent = false,
  hasCylindoDimensionShots = false,
  dimensionShotUrls = [],
  currentDimensionShot,
  selectedDimensionShotIndex = 0,
  setSelectedDimensionShotIndex,
}) => {
  const desktopImageFullWidthProps = useFixedWidthContainerSizeProps();

  const desktopImageProps = isSidebarContent
    ? { sizes: '30vw' }
    : desktopImageFullWidthProps;

  return (
    <>
      <MobileAndTabletOnly>
        {hasCylindoDimensionShots && currentDimensionShot ? (
          <PDPDimensionShotViewer
            dimensionShots={dimensionShotUrls}
            selectedDimensionShotIndex={selectedDimensionShotIndex}
            onIndexChange={setSelectedDimensionShotIndex}
            className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden aspect-[1/1]"
            sizes="100vw"
            height="900"
            width="900"
          />
        ) : (
          dimensionsMobileImage && (
            <JBImage
              src={dimensionsMobileImage}
              sizes="100vw"
              height="900"
              width="900"
              className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden"
            />
          )
        )}
      </MobileAndTabletOnly>

      <DesktopOnly>
        {hasCylindoDimensionShots && currentDimensionShot ? (
          <PDPDimensionShotViewer
            dimensionShots={dimensionShotUrls}
            selectedDimensionShotIndex={selectedDimensionShotIndex}
            onIndexChange={setSelectedDimensionShotIndex}
            className={classNames(
              'w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden aspect-[4/3]',
              {
                'hover:cursor-target': onImageClick,
              }
            )}
            onClick={onImageClick}
            {...desktopImageProps}
          />
        ) : (
          dimensionsDesktopImage && (
            <JBImage
              src={dimensionsDesktopImage}
              onClick={onImageClick}
              {...desktopImageProps}
              className={classNames(
                'w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden',
                {
                  'hover:cursor-target': onImageClick,
                }
              )}
            />
          )
        )}
      </DesktopOnly>
    </>
  );
};

PDPDimensionsImage.propTypes = {
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  hasCylindoDimensionShots: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensionCode: PropTypes.string.isRequired,
  }),
  selectedDimensionShotIndex: PropTypes.number,
  setSelectedDimensionShotIndex: PropTypes.func,
};

export default PDPDimensionsImage;
